import { Routes } from '@angular/router';
import { AuthLayoutComponent } from './layout/auth-layout/auth-layout.component';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { AuthGuard } from './guards/auth.guard';
import { PermissionsGuard } from './guards/permissions.guard';

export const routes: Routes = [
  {
    path: '',
    component: AuthLayoutComponent,
    children: [
      { path: '', redirectTo: 'login', pathMatch: 'full' },
      {
        path: 'login',
        loadComponent: () =>
          import('./pages/auth/login/login.component').then(
            (m) => m.LoginComponent
          ),
      },
      /*{
        path: 'recover-password',
        loadComponent: () =>
          import(
            './pages/auth/recover-password/recover-password.component'
          ).then((m) => m.RecoverPasswordComponent),
      },*/
    ],
  },
  {
    path: 'home',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, PermissionsGuard],
    children: [
      // Inicio
      {
        path: '',
        loadComponent: () =>
          import('./pages/home/home.component').then((m) => m.HomeComponent),
      },
      {
        path: 'home',
        loadComponent: () =>
          import('./pages/home/home.component').then((m) => m.HomeComponent),
      },
      // Casos
      {
        path: 'servicescases',
        loadComponent: () =>
          import('./pages/servicescases/servicescases.component').then(
            (m) => m.ServicesCasesComponent
          ),
      },
      // Registros
      {
        path: 'clients',
        loadComponent: () =>
          import('./pages/register/clients/clients.component').then(
            (m) => m.ClientsComponent
          ),
      },
      {
        path: 'vehicle',
        loadComponent: () =>
          import('./pages/register/vehicle/vehicles.component').then(
            (m) => m.VehicleComponent
          ),
      },
      // Operaciones
      {
        path: 'claims',
        loadComponent: () =>
          import('./pages/operations/claims/claims.component').then(
            (m) => m.ClaimsComponent
          ),
      },
      {
        path: 'diagnosis',
        loadComponent: () =>
          import('./pages/operations/diagnosis/diagnosis.component').then(
            (m) => m.DiagnosisComponent
          ),
      },
      {
        path: 'quotes',
        loadComponent: () =>
          import('./pages/operations/quotes/quotes.component').then(
            (m) => m.QuotesComponent
          ),
      },
      {
        path: 'appointments',
        loadComponent: () =>
          import('./pages/operations/appointments/appointments.component').then(
            (m) => m.AppointmentsComponent
          ),
      },
      {
        path: 'receptions',
        loadComponent: () =>
          import('./pages/operations/receptions/receptions.component').then(
            (m) => m.ReceptionsComponent
          ),
      },
      {
        path: 'workorders',
        loadComponent: () =>
          import('./pages/operations/workorders/workorders.component').then(
            (m) => m.WorkOrdersComponent
          ),
      },
      // Administrador
      {
        path: 'users',
        loadComponent: () =>
          import('./pages/administrator/users/users.component').then(
            (m) => m.UsersComponent
          ),
      },
      {
        path: 'insurance',
        loadComponent: () =>
          import('./pages/administrator/insurance/insurance.component').then(
            (m) => m.InsuranceComponent
          ),
      },
      {
        path: 'suppliers',
        loadComponent: () =>
          import('./pages/administrator/suppliers/suppliers.component').then(
            (m) => m.SuppliersComponent
          ),
      },

      {
        path: 'company',
        loadComponent: () =>
          import('./pages/administrator/company/company.component').then(
            (m) => m.CompanyComponent
          ),
      },
      {
        path: 'roles',
        loadComponent: () =>
          import('./pages/administrator/roles/roles.component').then(
            (m) => m.RolesComponent
          ),
      },
      // Inventario
      {
        path: 'items',
        loadComponent: () =>
          import('./pages/inventory/items/items.component').then(
            (m) => m.ItemsComponent
          ),
      },
      {
        path: 'deliverynotes',
        loadComponent: () =>
          import(
            './pages/inventory/delivery-notes/delivery-notes.component'
          ).then((m) => m.DeliveryNotesComponent),
      },
      {
        path: 'parts',
        loadComponent: () =>
          import('./pages/inventory/parts/parts.component').then(
            (m) => m.PartsComponent
          ),
      },
      {
        path: 'purchase-inventory',
        loadComponent: () =>
          import(
            './pages/inventory/purchase-inventory/purchase-inventory.component'
          ).then((m) => m.PurchaseInventoryComponent),
      },
      {
        path: 'purchaseorders',
        loadComponent: () =>
          import(
            './pages/inventory/purchase-orders/purchase-orders.component'
          ).then((m) => m.PurchaseOrdersComponent),
      },
      {
        path: 'returns',
        loadComponent: () =>
          import('./pages/inventory/returns/returns.component').then(
            (m) => m.ReturnsComponent
          ),
      },

      // Reportes
      {
        path: 'dashboard',
        loadComponent: () =>
          import('./pages/reports/dashboard/dashboard.component').then(
            (m) => m.DashboardComponent
          ),
      },
      {
        path: 'reports',
        loadComponent: () =>
          import('./pages/reports/report/report.component').then(
            (m) => m.ReportComponent
          ),
      },
      // Otros
      {
        path: 'settings',
        loadComponent: () =>
          import('./pages/settings/settings.component').then(
            (m) => m.SettingsComponent
          ),
      },
    ],
  },
  { path: '**', redirectTo: '' },
];
